// A block that opens a zone, drawn in that zone's own colours and texture: cross-promos inside zones and Home's portal
// banners.

import { h, link } from "../dom.ts";
import { icon } from "../icons.ts";
import { zoneVars } from "../tokens.ts";
import { zoneHref } from "./registry.ts";
import { mediaUrl, type Zone } from "./spec.ts";

/** One block that opens another zone, in that zone's own colours. Also Home's portal banner. */
export function promoBlock(z: Zone, placement: "banner" | "card" | "collection", copy?: string, art?: string, cta?: string, arg?: string, title?: string, eyebrow?: string): HTMLElement {
  // a collection promo opens that collection on the target page (Open Haunt → /store?collection=halloween)
  const href = placement === "collection" && arg ? `${zoneHref(z)}?collection=${encodeURIComponent(arg)}` : zoneHref(z);
  const el = link(
    href,
    { class: `zone-promo ${placement}`, "data-zone-promo": z.id },
    h("span", { class: "zone-promo-art", style: { backgroundImage: `url("${mediaUrl(art ?? z.hero.poster)}")`, backgroundPosition: `${z.hero.focal[0] * 100}% ${z.hero.focal[1] * 100}%` }, "aria-hidden": "true" }),
    h("span", { class: "zone-texture", "aria-hidden": "true" }),
    h(
      "span",
      { class: "zone-promo-text" },
      eyebrow ? h("span", { class: "zone-eyebrow" }, eyebrow) : null,
      h("strong", { class: "zone-promo-title" }, title ?? z.title),
      h("span", { class: "zone-promo-copy" }, copy ?? z.tagline),
      h("span", { class: "zone-promo-cta" }, cta ?? "Enter", icon("right", 14)),
    ),
  );
  el.dataset.texture = z.theme.texture;
  for (const [k, v] of Object.entries(zoneVars(z))) el.style.setProperty(k, v);
  return el;
}
